module.exports = __webpack_public_path__ + "images/business-live-trainings.png";